// extracted by mini-css-extract-plugin
export default {"home":"style_home__S1VPW","header":"style_header__6Axmc","title":"style_title__7W6S9"};